import { createFileRoute } from "@tanstack/react-router";
import ProcureIntegrations from "lib/components/procure/ProcureIntegrations";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../../../../components/withAuthentication";

function ProcureResourcesPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Estimate: Purchasable Items")}</title>
      </Head>
      <ProcureIntegrations path="resources" />
    </>
  );
}

export const Route = createFileRoute("/builders/$builder_id/estimate/integrations/resources")({
  component: withAuthentication(ProcureResourcesPage, { products: ["procure"] }),
});
